import { createSlice } from '@reduxjs/toolkit';
import {
  postGet,
  createPost,
  editPost,
  getTags,
  postData,
  LikePost,
  getPostDetail,
  getGroupPosts,
  reportComment
} from 'reduxStore/actions/posts';

const initialState = {
  userLoading: false,
  post: [],
  tags: [],
  error: null,
  likesList: {},
  postDetail: null,
  groupPosts: [],
  groupPostsPagination: null,
  
};

const postSlice = createSlice({
  name: 'post',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Separate pending cases for each action
      .addCase(postGet.pending, (state) => {
        state.userLoading = true;
        state.error = null;
      })
      .addCase(getTags.pending, (state) => {
        state.userLoading = true;
        state.error = null;
      })
      .addCase(postData.pending, (state) => {
        state.userLoading = true;
        state.error = null;
      })
      .addCase(createPost.pending, (state) => {
        state.userLoading = true;
        state.error = null;
      })
      .addCase(editPost.pending, (state) => {
        state.userLoading = true;
        state.error = null;
      })
      .addCase(LikePost.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPostDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getGroupPosts.pending, (state) => {
        state.userLoading = true;
        state.error = null;
      })

      // Fulfilled cases
      .addCase(postGet.fulfilled, (state, action) => {
        state.userLoading = false;
        if (action.payload?.success && action.payload?.data?.rows) {
          state.post = action.payload.data;
        } else {
          state.error = action.payload?.message || 'Failed to fetch post';
        }
      })

      .addCase(createPost.fulfilled, (state, action) => {
        state.userLoading = false;
        if (action.payload?.success && action.payload?.data?.rows) {
        //   state.post = action.payload.data.rows;
        } else {
          state.error = action.payload?.message || 'Failed to fetch post';
        }
      })

      .addCase(postData.fulfilled, (state, action) => {
        state.userLoading = false;
        if (action.payload?.success && action.payload?.data?.rows) {
          state.post = action.payload.data.rows;
        } else {
          state.error = action.payload?.message || 'Failed to fetch post';
        }
      })

      .addCase(editPost.fulfilled, (state, action) => {
        state.userLoading = false;
        if (action.payload?.success && action.payload?.data?.rows) {
          state.post = action.payload.data.rows;
        } else {
          state.error = action.payload?.message || 'Failed to fetch post';
        }
      })

      .addCase(getTags.fulfilled, (state, action) => {
        state.userLoading = false;
        if (action.payload?.success && action.payload?.data) {
          state.tags = action.payload.data;
        } else {
          state.error = action.payload?.message || 'Failed to fetch tags';
        }
      })

      .addCase(LikePost.fulfilled, (state, action) => {
        const { like_count  } = action.payload;
        const updatedPostId = action.meta.arg.post_id;
        if (updatedPostId && state.post?.rows) {
          const postIndex = state.post.rows.findIndex(post => post.post_id === updatedPostId);
          if (postIndex !== -1) {
            state.post.rows[postIndex].like_count = like_count;
          }
        }
      })

      .addCase(getPostDetail.fulfilled, (state, action) => {
        state.userLoading = false;
        if (action.payload) {
          state.postDetail = action.payload.data;
        } else {
          state.error = action.payload?.message || 'Failed to fetch post';
        }
      })

      .addCase(getGroupPosts.fulfilled, (state, action) => {
        state.userLoading = false;
        if (action.payload?.success && action.payload?.data) {
          state.groupPosts = action.payload.data.posts;
          state.groupPostsPagination = action.payload.data.pagination;
        } else {
          state.error = action.payload?.message || 'Failed to fetch group posts';
        }
      })

      .addCase(reportComment.fulfilled, (state, action) => {
        state.userLoading = false;
        state.error = null;
      })

      // Separate rejected cases for each action
      .addCase(postGet.rejected, (state, action) => {
        console.error('Error fetching post:', action.error.message);
        state.userLoading = false;
        state.error = action.error.message;
      })
      .addCase(createPost.rejected, (state, action) => {
        console.error('Error creating post:', action.error.message);
        state.userLoading = false;
        state.error = action.error.message;
      })
      .addCase(getTags.rejected, (state, action) => {
        console.error('Error fetching tags:', action.error.message);
        state.userLoading = false;
        state.error = action.error.message;
      })
      .addCase(postData.rejected, (state, action) => {
        console.error('Error fetching post data:', action.error.message);
        state.userLoading = false;
        state.error = action.error.message;
      })
      .addCase(editPost.rejected, (state, action) => {
        console.error('Error editing post:', action.error.message);
        state.userLoading = false;
        state.error = action.error.message;
      })
      .addCase(LikePost.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Something went wrong';
      })
      .addCase(getPostDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getGroupPosts.rejected, (state, action) => {
        state.userLoading = false;
        state.error = action.payload || 'Failed to fetch group posts';
      })
      .addCase(reportComment.rejected, (state, action) => {
        state.userLoading = false;
        state.error = action.payload;
      })
  },
});

export default postSlice.reducer;
